import Vue from 'vue'
import App from './App'
import store from './store/store'
import vuetify from './plugins/vuetify'
import router from '@/router/router'
import axios from 'axios'
import '@/styles/index.scss'

axios('config/custom-config.json')
  .then(config => {
    Vue.prototype.$appConfig = config.data
  })
  .catch(error => {
    console.warn(`Не удалось найти файл настроек: ${error}`)

    Vue.prototype.$appConfig = {
      subPath: '/verify/',
      baseURL: 'https://dss-astra-se16/vs/rest/api',
      footerText: '© ООО «КРИПТО-ПРО» 2000-2022',
      logoURL: '',
      helpURL: '',
      previewLoadTimeout: 20,
      color: {
        mainDark: '#444444',
        mainLight: '#f6f6f6',
        secondary: '#2967b1',
        textLight: '#f6f6f6',
        textDark: '#444444',
        icon: '#444444',
        error: '#E30520',
        success: '#00A969'
      },
      demoWarn: false,
      demoWarnText: 'Тестовая служба проверки подписи и сертификатов «КриптоПро SVS». Результаты проверки могут быть использованы исключительно в ознакомительных целях.'
    }
  })
  .finally(() => {
    Vue.prototype.$request = axios.create({
      baseURL: Vue.prototype.$appConfig.baseURL,
      timeout: 60 * 1000,
      withCredentials: true,
      headers: {
        Pragma: 'no-cache',
        'Cache-Control': 'no-store'
      }
    })

    new Vue({
      store,
      vuetify,
      router: router(),
      render: h => h(App)
    }).$mount('#app')
  })
